import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import AppShell from "./components/AppShell";
import { Login, Onboarding } from "./pages/Auth";
import { PublicPage, QRResolve, CardResolve, PaymentResult } from "./pages/Public";
import PagesList from "./pages/PagesList";
import PageEditor from "./pages/PageEditor";
import { QRList, QREditor } from "./pages/QR";
import { Physical, CardOrder, OrderDetail } from "./pages/Physical";
import { Overview, Leads, Team, Settings } from "./pages/Dashboard";
import SuperLayout, { SADashboard, SAAccounts, SAOrg, SAUsers, SAPlans, SAProducts, SACoupons, SAFulfilment, SASerials, SAModeration, SASettings, SAAudit } from "./pages/Superadmin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route path="/q/:code" element={<QRResolve />} />
          <Route path="/c/:serial" element={<CardResolve />} />
          <Route path="/dashboard" element={<AppShell />}>
            <Route index element={<Overview />} />
            <Route path="cards" element={<Physical />} />
            <Route path="physical/*" element={<Navigate to="/dashboard/cards" replace />} />
            <Route path="pages" element={<PagesList type="landing_page" />} />
            <Route path="editor/:id" element={<PageEditor />} />
            <Route path="qr" element={<QRList />} />
            <Route path="qr/:id" element={<QREditor />} />
            <Route path="cards/order" element={<CardOrder />} />
            <Route path="cards/orders/:id" element={<OrderDetail />} />
            <Route path="leads" element={<Leads />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/:tab" element={<Settings />} />
          </Route>
          <Route path="/superadmin" element={<SuperLayout />}>
            <Route index element={<SADashboard />} />
            <Route path="accounts" element={<SAAccounts />} />
            <Route path="accounts/:id" element={<SAOrg />} />
            <Route path="users" element={<SAUsers />} />
            <Route path="plans" element={<SAPlans />} />
            <Route path="products" element={<SAProducts />} />
            <Route path="coupons" element={<SACoupons />} />
            <Route path="fulfilment" element={<SAFulfilment />} />
            <Route path="serials" element={<SASerials />} />
            <Route path="moderation" element={<SAModeration />} />
            <Route path="settings" element={<SASettings />} />
            <Route path="audit" element={<SAAudit />} />
          </Route>
          <Route path="/:slug" element={<PublicPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
